import {Component, OnDestroy, OnInit} from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Meta, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { ActivatedRoute, Router } from '@angular/router';
import { SeoService } from '../common/services/seo.service';
import {PostsService} from '../common/services/posts.service';
import {PostDO} from '../common/data-objects/PostDO';
import {IPageChangeData} from '../common/data-objects/IPageChangeData';

@Component({
  selector: 'app-songs-page',
  templateUrl: './songs-page.component.html',
  styleUrls: ['./songs-page.component.scss']
})
export class SongsPageComponent implements OnInit, OnDestroy {
  posts: PostDO[];
  itemsCount: number;
  isLoading = true;
  pagesCount: number;
  private getDataSubscription: Subscription;

  constructor(
    private toastr: ToastrService,
    private titleService: Title,
    private angulartics2: Angulartics2,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private meta: Meta,
    private seoService: SeoService,
    private postsService: PostsService
  ) {
    this.seoService.setTitle('Cântece creștine pentru copii - Fun Bible');
    this.seoService.setDescription( 'Cântece pentru copii pe diverse teme biblice');
    this.meta.updateTag({ property: 'og:url', content: 'https://funbible.net/songs/' });
    this.meta.updateTag({ property: 'og:image', content: 'https://funbible.net/assets/sing.png' });
    const initialKeywords = ['cantece crestine', 'muzica pentru copii', 'cantecele pentru copii', 'melodii pentru copii', 'muzica copii', 'cantece pentru copiii', 'cantece de copii', 'cantecegradinita', 'muzica pt copi', 'cantece de copi'].join();
    this.meta.updateTag({property: 'keywords', content: initialKeywords});
    this.angulartics2.eventTrack.next({
      action: 'songs',
      properties: { category: 'pageView' },
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.getDataSubscription) {
      this.getDataSubscription.unsubscribe();
    }
  }

  getData({searchText, page}: IPageChangeData) {
    this.isLoading = true;
    this.getDataSubscription = this.postsService.getSongsPages(searchText, page).subscribe((postsData) => {
      this.posts = postsData.posts;
      this.pagesCount = postsData.pagesCount;
      this.itemsCount = postsData.itemsCount;
      this.isLoading = false;
    }, () => {
      this.toastr.error('Acest conținut nu s-a putut încărca!');
      this.isLoading = false;
    });
  }
}
